export default __webpack_public_path__ + "33f11e8e33e406b0dc21a378dd3efeb4.svg";